import supabase from 'lib/supabase-browser'
import { requestTranscriptionAPI } from './db'
import { Submission } from 'lib/types/generated-types'
import { UploadMethod } from 'store/useStore'

export async function requestTranscription(
  submission: Submission,
  userId: string,
  type: UploadMethod
) {
  const {
    data: { session },
  } = await supabase.auth.getSession()
  if (!session) {
    throw new Error('No session')
  }

  const transcription = await requestTranscriptionAPI({
    submission,
    session,
    uid: userId,
    type,
  })

  return transcription
}
